import { ICON } from 'utilsTS/icon';
import Enum from './Enum';

export default function pickEnumProps(Component) {
    const { ...props } = Component;

    return Object.keys(props).reduce((previous, key) => {
        const prop = props[key];
        if (prop instanceof Enum || prop === ICON) {
            return {
                ...previous,
                [key]: prop,
            };
        }
        return previous;
    }, {});
}
